import { Injectable } from '@angular/core';
import { AttributeBase, LegAttribute } from '@approot/models';
import { ButtonAttribute } from '@approot/models/attribute-button';
import { DateAttribute } from '@approot/models/attribute-date';
import { DropdownAttribute } from '@approot/models/attribute-dropdown';
import { ListAttribute } from '@approot/models/attribute-list';
import { TextboxAttribute } from '@approot/models/attribute-textbox';
import { ProductsConfigService } from '@approot/services/products-config/products-config.service';
import { clone } from '@approot/utilities';

@Injectable({
  providedIn: 'root'
})
export class AttributeFormGeneratorService {
  constructor(private productsConfigService: ProductsConfigService) {}

  convertAttributesIntoControls(
    attributes: LegAttribute[],
    parentShortname?: string
  ): AttributeBase<any>[] {
    const attributesAsControls: AttributeBase<any>[] = [];

    if (attributes.length) {
      attributes.forEach(attribute => {
        const globalAttributes = clone(
          this.productsConfigService.productInfo.attributesDisplayList.find(
            displayListAttribute =>
              displayListAttribute.shortName === parentShortname ||
              displayListAttribute.shortName === attribute.shortName
          )
        );

        if (globalAttributes) {
          delete globalAttributes.shortName;
        }

        if (globalAttributes) {
          delete globalAttributes.longName;
        }

        const attributeOptions = {
          key: attribute.shortName,
          attributeType: attribute.attributeType,
          type: attribute.type,
          value: attribute.value,
          required: attribute.optional === 'false' || !attribute.optional,
          readOnly: attribute.readOnly === 'true',
          validator: attribute['validator'] || attribute.validators,
          hide: attribute.hide === 'true',
          disabled: attribute.disabled === 'true',
          initialValue: attribute.initialValue,
          format: attribute.format,
          decimalPlaces: attribute.dp,
          default: attribute.default,
          attributesDisabledOnNone: attribute.attributesDisabledOnNone,
          allowSyncLegs: attribute.allowSyncLegs,
          hideInRfqPanel: attribute.hideInRfqPanel,
          selectFirst: attribute.selectFirst,
          source: attribute.source,
          currencyAttribute: attribute.currencyAttribute,
          ...globalAttributes
        };
        switch (attribute.type) {
          case 'string':
            attributesAsControls.push(new TextboxAttribute(attributeOptions));
            break;
          case 'number':
            attributesAsControls.push(new TextboxAttribute(attributeOptions));
            break;
          case 'enum':
          case 'multiSelect':
            attributesAsControls.push(
              new DropdownAttribute({
                ...attributeOptions,
                value: attributeOptions.initialValue,
                options: attributeOptions.value,
                controlType:
                  attributeOptions.type === 'enum' ? 'dropdown' : 'multiSelect'
              })
            );
            break;
          case 'editableDate':
          case 'date':
            attributesAsControls.push(new DateAttribute(attributeOptions));
            break;
          case 'button':
            attributesAsControls.push(new ButtonAttribute(attributeOptions));
            break;
          case 'list':
          case 'bidAskList':
            attributesAsControls.push(
              new ListAttribute({
                ...attributeOptions,
                controlType: attribute.type,
                attributes: this.convertAttributesIntoControls(
                  attribute.attributes,
                  attribute.shortName
                )
              })
            );
            break;
          default:
          // code block
        }
      });
    }

    return attributesAsControls;
  }
}
